export enum BulkNotificationCampaignTypeEnum {
	ONE_TIME = 'one_time',
	RECURRENT = 'recurrent',
}

export enum BulkNotificationCampaignStatusEnum {
	PENDING = 'pending',
	RUNNING = 'running',
	COMPLETED = 'completed',
	CANCELLED = 'cancelled',
	ERROR = 'error',
}

export enum MobilePlatformEnum {
	IOS = 'ios',
	ANDROID = 'android',
}

export enum AppVersionOpEnum {
	GTE = 'gte',
	LTE = 'lte',
}
